import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { formatCFA } from '@/lib/utils'
import type { BarDatumNV } from '@/types/backend'
import { ResponsiveBar } from '@nivo/bar'
import React from 'react'

type Props = {
  data: BarDatumNV[]
  gridColor: string
  gridOpacity: number
  emptyMsg?: string
}

const BilanDepenses: React.FC<Props> = ({
  data,
  gridColor,
  gridOpacity,
  emptyMsg = 'Aucune dépense sur la période.',
}) => {
  const safe = data?.length ? data : [{ name: '', value: 0 }]
  return (
    <Card className='min-h-[360px]'>
      <CardHeader>
        <h4 className='text-lg font-medium'>Dépenses par mois</h4>
      </CardHeader>
      <CardContent className='h-[300px]'>
        <ResponsiveBar<BarDatumNV>
          data={safe}
          keys={['value']}
          indexBy='name'
          margin={{ top: 10, right: 10, bottom: 40, left: 48 }}
          padding={0.3}
          borderRadius={6}
          axisBottom={{ tickPadding: 12, tickRotation: -30 }}
          axisLeft={{ tickPadding: 6 }}
          enableLabel={false}
          theme={{
            grid: { line: { stroke: gridColor, strokeOpacity: gridOpacity } },
            tooltip: { container: { fontSize: 12, borderRadius: 8 } },
          }}
          colors={['#ef4444']}
          tooltip={({ value, indexValue }) => (
            <div className='rounded-md border dark:bg-primary bg-white p-2 text-xs shadow'>
              <div>
                Mois: <b>{String(indexValue)}</b>
              </div>
              <div>
                Dépenses: <b>{formatCFA(Number(value))}</b>
              </div>
            </div>
          )}
        />
        {!data?.length && (
          <div className='mt-2 text-center text-xs text-muted-foreground'>
            {emptyMsg}
          </div>
        )}
      </CardContent>
    </Card>
  )
}

export default BilanDepenses
